import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { watch, onBeforeUnmount } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MensajeFlotante',
  props: {
    visible: { type: Boolean },
    mensaje: {},
    tipo: {}
  },
  emits: ["cerrar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Mensaje flotante de estado.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

let timer: ReturnType<typeof setTimeout> | null = null

watch(() => props.visible, (val) => {
  if (timer) { clearTimeout(timer); timer = null }
  if (val) {
    timer = setTimeout(() => emit('cerrar'), 2500)
  }
})

onBeforeUnmount(() => { if (timer) clearTimeout(timer) })

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["mensaje-flotante", _ctx.tipo])
      }, [
        _createElementVNode("button", {
          class: "cerrar",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cerrar')))
        }, "×"),
        _createElementVNode("p", null, _toDisplayString(_ctx.mensaje), 1)
      ], 2))
    : _createCommentVNode("", true)
}
}

})